import { CreatedReport, ExpiredReport, ReportMetadata } from '../../interfaces';

export type RegeneratedReport = CreatedReport | ExpiredReport;
export type RegeneratedReportMetaData = ReportMetadata;

export enum REGENERATE_REPORT_BUSINESS_ERRORS {
  REPORT_NOT_FOUND = 'REPORT_NOT_FOUND',
  REPORTS_LIMIT_REACHED = 'REPORTS_LIMIT_REACHED'
}

export type HandleRegenerateReportRequest = (id: string) => Promise<Response>;
export type HandleOpenRegenerateDialog = (item: RegeneratedReport) => void;
